import { Component, OnInit } from '@angular/core';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import jspdf from 'jspdf';
import { GlobalService } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DonationService } from 'src/app/shared/services/donation.service';
import { GetDonationHistory } from 'src/app/shared/models/get-donation-history.model';
import { DonationHistory } from '../../member/donation-history/donation-history.model';
import { TenantService } from 'src/app/tenant/tenant.service';
import { MemberService } from 'src/app/shared/services/member.service';
import { ProfileService } from 'src/app/shared/profile/profile/profile.service';


@Component({
    selector: 'app-my-statement',
    templateUrl: './my-statement.component.html',
    styleUrls: ['./my-statement.component.scss'],
    standalone: false
})

export class MyStatementComponent implements OnInit {
  isMemberHeader: boolean = true;
  isGivingLoading: boolean = true;
  isLoading: boolean = true;
  selectedYear: number;
  memberId: string;
  result: GetDonationHistory;
  data: DonationHistory[];
  logoSource: string = '';
  churchName: string = '';
  period: string = '';
  total: number = 0;
  taxId: string = '';
  currentDate: Date = new Date();

  constructor(public globalService: GlobalService,
    private route: ActivatedRoute,
    private _location: Location,
    private _router: Router,
    private donationService: DonationService,
    private tenantService: TenantService,
    private memberService: MemberService,
    private profileService: ProfileService) { }

  async ngOnInit() {
    
    var tenantData = await this.tenantService.getSimpleTenant(); 
    this.taxId= tenantData.taxId;
    this.churchName = tenantData.name;    
    this.logoSource = await this.tenantService.getTenantSmallLogo(tenantData.subdomain);    
    var Member = await this.profileService.getMember(this.globalService.currentUserId);
    this.memberId = Member.id.toString();
    this.selectedYear = this.route.snapshot.params.year;
    this.period = '01/01/'+ this.selectedYear + ' - ' + '12/31/' + this.selectedYear; 
    this.result = await this.donationService.getDonationsByMember(this.memberId);
    this.UpdateView();
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = this.globalService.Get('TAX_STATEMENT');
    this.isLoading = false;
  } 

  UpdateView() {
    var filteredSet: any[];
    filteredSet = this.result.donations.filter(a =>
      (this.selectedYear == 0 || a.year == this.selectedYear) &&
      (a.taxDeductible == true)
    ).sort((x, y) => x.chargeDate > y.chargeDate ? -1 : 1);

    this.data = filteredSet.map(b => {
      let s: DonationHistory = new DonationHistory();
      s.chargeId = b.chargeId;
      s.donationDate = b.chargeDate;
      s.donationAmount = b.amount;
      s.givingType = b.givingType;
      return s;
    });
    this.total = this.data.reduce((sum, current) => sum + current.donationAmount, 0);
  }

  exportAsPDF(divId) {
    var element = document.getElementById(divId);
    var opt = {
      margin: 0.5,
      filename: 'statement.pdf',
      image: { type: 'jpg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        dpi: 300,
        letterRendering: true,
        useCORS: true
        },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf(element, opt);
  }
}


